import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { Link } from "react-router";
import ButtonClose from "../buttonClose/.mixins/buttonClose";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

export const DialogConfirm = ({open, onClose, message, strongMessage, linkToGo, buttonName, title}) => {

    return (
        <Dialog
            open={open}
            keepMounted
            onClose={() => {onClose()}}
        >
            <DialogTitle>
                {/* {title} */}
                <Typography variant="body1" align="center" style={{ marginLeft: "20px" }}>
                    <ButtonClose closeMethod={() => {onClose()}} />
                    <strong>{title}</strong>
                </Typography>
            </DialogTitle>
            <DialogContent>
                <div align="center">
                    <FontAwesomeIcon style={{marginBottom: '0.5em'}} color='#FEBC28' icon={faExclamationCircle} size='3x'/>
                    <Typography variant="body1" align="center">
                        {strongMessage && <strong>
                            {strongMessage}
                        </strong>}
                        {message}
                    </Typography>
                </div>
            </DialogContent>
            <DialogActions>
                <Typography style={{ padding: "0px", margin: "0 1em 1em 0" }} align="center">
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ padding: "7.5px 20px" }}
                    >
                        <Link style={{color: 'white'}} to={linkToGo}  children={buttonName}/>
                    </Button>
                </Typography>
            </DialogActions>
        </Dialog>
    )
}